import styled from 'styled-components';
import DisplayTextBlock from '@carvana/showroom-content/TextBlock/Display';
import ChatWithUsSvg from '../../../../../images/icons/chat-with-us.svg';

export const StyledContainer = styled.div`
  max-width: 390px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`;

export const StyledButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const StyledChatIcon = styled(ChatWithUsSvg)`
  width: 64px;
  height: 64px;
`;

export const StyledChatIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  padding-bottom: 4px;
  margin-bottom: 1rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.carvana.blue.primary};
`;

export const StyledTextBlock = styled.div`
  font-size: 0.875rem;
`;

export const StyledText = styled(DisplayTextBlock.SmallTitle)``;
